import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'
import '@/assets/styles/index.scss'

import './permission'
import RichEditor from '@/components/RichEditor/index.vue'

Vue.use(ElementUI, { size: 'small' })
Vue.component('RichEditor', RichEditor)

Vue.config.productionTip = false

// 静默处理 Vue Router 的预期重定向/重复导航错误，避免控制台报错
Vue.config.errorHandler = (err, vm, info) => {
  if (err && (err.name === 'NavigationDuplicated' || err.name === 'NavigationRedirected')) {
    return
  }
  if (typeof console !== 'undefined' && console.error) {
    console.error(err, info)
  }
}

// 全局权限指令
function checkPermission(el, binding) {
  const { value } = binding
  if (!value || !Array.isArray(value) || value.length === 0) {
    el.style.display = ''
    return
  }
  const permissions = store.getters.permissions || []
  const roles = store.getters.roles || []
  // roles 支持字符串数组或对象数组（兼容后端返回 [{code:'super_admin'}] 的情况）
  const roleList = roles.map(r => (typeof r === 'string' ? r : (r.code || r.name || r)))
  const hasPermission =
    roleList.includes('super_admin') ||
    roleList.includes('admin') ||
    value.some(perm => permissions.includes(perm))
  el.style.display = hasPermission ? '' : 'none'
}

Vue.directive('permission', {
  inserted(el, binding) {
    checkPermission(el, binding)
    // 通过 store.subscribe 精准监听权限相关 mutation，比 store.watch 更可靠
    const unsubscribe = store.subscribe((mutation) => {
      if (
        mutation.type === 'user/SET_PERMISSIONS' ||
        mutation.type === 'user/SET_ROLES'
      ) {
        Vue.nextTick(() => checkPermission(el, binding))
      }
    })
    el._permissionUnsubscribe = unsubscribe
  },
  update(el, binding) {
    checkPermission(el, binding)
  },
  unbind(el) {
    if (el._permissionUnsubscribe) {
      el._permissionUnsubscribe()
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
